import { HERO_SERVICE } from "@/services/hero.service.js";

const state = {postHeroOutput: false, getHeroOutput: {}, putHeroOutput: false, deleteHeroByIdOutput: false, getHeroByIdOutput: {}};

const actions = {
    //Service to create hero items
    postHero({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postHeroRequest');

        HERO_SERVICE.postHero(input)
            .then(
                output => {
                    commit('postHeroSuccess', output);
                },
                error => {
                    commit('postHeroFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Endpoint to get hero items
    getHero({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getHeroRequest');

        HERO_SERVICE.getHero(queryParams)
            .then(
                output => {
                    commit('getHeroSuccess', output);
                },
                error => {
                    commit('getHeroFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update hero items
    putHero({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putHeroRequest');

        HERO_SERVICE.putHero(input)
            .then(
                output => {
                    commit('putHeroSuccess', output);
                },
                error => {
                    commit('putHeroFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to remove hero items
    deleteHeroById({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteHeroByIdRequest');

        HERO_SERVICE.deleteHeroById(queryParams)
            .then(
                output => {
                    commit('deleteHeroByIdSuccess', output);
                },
                error => {
                    commit('deleteHeroByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get hero item details
    getHeroById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getHeroByIdRequest');

        HERO_SERVICE.getHeroById(id)
            .then(
                output => {
                    commit('getHeroByIdSuccess', output);
                },
                error => {
                    commit('getHeroByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postHero
    postHeroRequest(state) {
        state.postHeroOutput = null;
    },
    postHeroSuccess(state, output) {
        state.postHeroOutput = true;
    },
    postHeroFailure(state) {
        state.postHeroOutput = false;
    },

    //getHero
    getHeroRequest(state) {
    },
    getHeroSuccess(state, output) {
        state.getHeroOutput = output;
    },
    getHeroFailure(state) {
        state.getHeroOutput = false;
    },

    //putHero
    putHeroRequest(state) {
        state.putHeroOutput = null;
    },
    putHeroSuccess(state, output) {
        state.putHeroOutput = true;
    },
    putHeroFailure(state) {
        state.putHeroOutput = false;
    },

    //deleteHeroById
    deleteHeroByIdRequest(state) {
        state.deleteHeroByIdOutput = null;
    },
    deleteHeroByIdSuccess(state, output) {
        state.deleteHeroByIdOutput = true;
    },
    deleteHeroByIdFailure(state) {
        state.deleteHeroByIdOutput = false;
    },

    //getHeroById
    getHeroByIdRequest(state) {
    },
    getHeroByIdSuccess(state, output) {
        state.getHeroByIdOutput = output;
    },
    getHeroByIdFailure(state) {
        state.getHeroByIdOutput = false;
    },
};

export const hero = {
    namespaced: true,
    state,
    actions,
    mutations
};